/*====================================================
	Herobanner Home Slider
====================================================*/
const selector_hero = 'js__slider-herobanner';

const elements_hero = document.querySelectorAll(
	`.${selector_hero}`
);

if (elements_hero.length > 0) {
    for (const element of elements_hero) {
        buildSwiperHero(element);
    }
}

function buildSwiperHero(swiperElement) {
    const sliderIdentifier = swiperElement.dataset.swiperId;
	let autoplayDelay = document.querySelector('.js_autoplay-delay');
	autoplayDelay = autoplayDelay ? parseInt(autoplayDelay.getAttribute('data-delay'), 10) : 5000; 

    let thumbSlider = new Swiper(`#swiper-thumbnails-${sliderIdentifier}`, {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        breakpoints: {
            550: {
                spaceBetween: 20,
            },
        },
    });

    let mainSlider = new Swiper(`#swiper-${sliderIdentifier}`, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        autoplay: {
            delay: autoplayDelay,
        },
        thumbs: {
            swiper: thumbSlider,
        }
    });

    mainSlider.on('slideChange', function () {
        let currentIndex = mainSlider.realIndex;
    });

    // Reset autoplay on thumbnail click
    function resetAutoplay() {
        mainSlider.autoplay.stop();
        mainSlider.autoplay.start();
    }

    thumbSlider.on('click', function () {
        resetAutoplay();
    });
}
